export default "__VITE_ASSET__fcf67d67__"